//dependencies
import { formatISO, startOfMinute } from "date-fns";

import { FormsINeedToDoFilters } from "./components/FormsINeedToDoFilterPanel";

export const getFiltersForSearchService = (filters: FormsINeedToDoFilters, userId: string, searchTerm?: string) => {
	const baseFilters = {
		completed_ne: true,
		upcoming_authors_or_upcoming_signers_eq: userId,
		author_or_signer_eq: userId,
		start_date_lt: formatISO(startOfMinute(new Date())),
		form_name_re: searchTerm,
	};

	if (filters.subject) {
		baseFilters["subject_eq"] = filters.subject.id;
	}

	if (filters.status && filters.status !== "any") {
		baseFilters["status_eq"] = [filters.status];
	}

	return baseFilters;
};
